import { IconProps } from "../../types/utils";

const Label = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.9241 8.03037C24.2086 8.31484 24.3507 8.59929 24.3507 8.88377L24.9196 14.2881C24.9196 14.7147 24.7775 15.1415 24.493 15.426L15.3909 24.5282C14.8219 25.0971 13.9687 25.0971 13.3998 24.5282L7.42629 18.5547C6.85737 17.9858 6.85737 17.1326 7.42629 16.5636L16.5285 7.46141C16.8128 7.17694 17.2396 7.03463 17.6662 7.03463L23.0705 7.60354C23.355 7.60354 23.6394 7.74586 23.9239 8.03015L23.9241 8.03037ZM24.9194 7.03463C24.4928 6.60802 23.9239 6.32354 23.2128 6.18123L17.808 5.6125C16.9548 5.47018 16.1014 5.75464 15.5325 6.46589L6.43031 15.5681C5.29244 16.706 5.29244 18.4126 6.43031 19.5502L12.4038 25.5237C13.5417 26.6616 15.2483 26.6616 16.3859 25.5237L25.4881 16.4215C26.1994 15.8526 26.4838 14.9992 26.3415 14.146L25.7726 8.74165C25.6304 8.03038 25.346 7.46164 24.9194 7.03486L24.9194 7.03463Z"
      fill={color || "#242424"}
    />
    <path
      d="M20.5107 11.5858C21.0796 12.1547 21.0796 13.0079 20.5107 13.5768C19.9417 14.1458 19.0885 14.1458 18.5196 13.5768C17.9507 13.0079 17.9507 12.1547 18.5196 11.5858C18.9462 11.0168 19.9417 11.0168 20.5107 11.5858ZM21.5062 10.4479C20.3683 9.31001 18.6617 9.31001 17.5241 10.4479C16.3862 11.5858 16.3862 13.2924 17.5241 14.43C18.6619 15.5679 20.3685 15.5679 21.5062 14.43C22.5017 13.4345 22.5017 11.5857 21.5062 10.4479Z"
      fill={color || "#242424"}
    />
    <path
      d="M10.8397 19.1238C10.5553 19.4083 10.1286 19.4083 9.8442 19.1238C9.55976 18.8394 9.55973 18.4127 9.8442 18.1283L10.2708 17.5594L13.8263 14.0039C14.1108 13.7194 14.5374 13.7194 14.8219 14.0039C15.1063 14.2883 15.1063 14.715 14.8219 14.9994L14.3953 15.5683L10.8397 19.1238Z"
      fill={color || "#242424"}
    />
    <path
      d="M13.9686 22.1102C13.6842 22.3947 13.2575 22.3947 12.9731 22.1102C12.6886 21.8257 12.6886 21.3991 12.9731 21.1147L13.3997 20.5458L16.3865 17.5591L16.9554 16.9902C17.2399 16.7057 17.6665 16.7057 17.9509 16.9902C18.2354 17.2747 18.2354 17.7013 17.9509 17.9857L17.382 18.5547L14.3954 21.6836L13.9686 22.1102Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Label;
